import { Injectable } from "@angular/core";

import { generateUUID } from "@utils/encrypt/encrypt";

@Injectable({ providedIn: "root" })
export class TracingContextService {
  private _sessionId: string | null = null;
  private _traceparent: string | null = null;

  get sessionId(): string | null {
    return this._sessionId;
  }

  get traceparent(): string | null {
    return this._traceparent;
  }

  /**
   * Lê vss-session-id e traceparent direto de window.location.search.
   * Deve ser chamado no AppComponent.ngOnInit() — window.location está
   * disponível sincronamente, ao contrário de ActivatedRoute.snapshot
   * que ainda não foi processado nesse momento do ciclo de vida.
   */
  initFromUrl(): void {
    const params = Object.fromEntries(new URLSearchParams(window.location.search).entries());
    this.init(params);
  }

  /**
   * Inicializa o contexto a partir de um mapa de parâmetros.
   * Separado de initFromUrl() para permitir testes sem acesso a window.location.
   *
   * Playbook de observabilidade (correlation-id §3.3): o cliente deve gerar um
   * traceparent na abertura da sessão quando nenhum foi recebido (ex: deep link),
   * nunca operar sem trace_id.
   */
  init(queryParams: Record<string, string>): void {
    this._sessionId = queryParams["vss-session-id"] || null;
    this._traceparent = queryParams["traceparent"] || this.generateTraceparent();
  }

  private generateTraceparent(): string {
    const traceId = generateUUID().replace(/-/g, "");
    const parentId = generateUUID().replace(/-/g, "").slice(0, 16);
    return `00-${traceId}-${parentId}-01`;
  }
}
